// lingland-frontend/src/components/SchemaMarkup.js
import React from 'react';
import { Helmet } from 'react-helmet-async';

const SchemaMarkup = ({ type, data }) => {
    const getSchemaData = () => {
        const baseUrl = 'https://lingland.pl';
        
        switch (type) {
            case 'Organization':
                return {
                    "@context": "https://schema.org",
                    "@type": "Organization",
                    "name": "Lingland",
                    "description": "Profesjonalne usługi tłumaczeniowe i lokalizacyjne",
                    "url": baseUrl,
                    "logo": `${baseUrl}/logo192.png`,
                    "contactPoint": {
                        "@type": "ContactPoint",
                        "telephone": "+48-123-456-789",
                        "contactType": "customer service",
                        "availableLanguage": ["Polish", "English"]
                    },
                    "address": {
                        "@type": "PostalAddress",
                        "addressCountry": "PL"
                    },
                    "sameAs": [
                        "https://www.linkedin.com/company/lingland",
                        "https://www.facebook.com/lingland"
                    ]
                };

            case 'WebSite':
                return {
                    "@context": "https://schema.org",
                    "@type": "WebSite",
                    "name": "Lingland",
                    "url": baseUrl,
                    "description": "Profesjonalne usługi tłumaczeniowe i lokalizacyjne",
                    "potentialAction": {
                        "@type": "SearchAction",
                        "target": {
                            "@type": "EntryPoint",
                            "urlTemplate": `${baseUrl}/blog?search={search_term_string}`
                        },
                        "query-input": "required name=search_term_string"
                    }
                };

            case 'Service':
                return {
                    "@context": "https://schema.org",
                    "@type": "Service",
                    "name": data.name || "Usługi Tłumaczeniowe",
                    "description": data.description || "Profesjonalne tłumaczenia dokumentów, stron internetowych i aplikacji",
                    "provider": {
                        "@type": "Organization",
                        "name": "Lingland",
                        "url": baseUrl
                    },
                    "serviceType": "Translation Services",
                    "areaServed": {
                        "@type": "Country",
                        "name": "Poland"
                    },
                    "hasOfferCatalog": {
                        "@type": "OfferCatalog",
                        "name": "Translation Services",
                        "itemListElement": [
                            {
                                "@type": "Offer",
                                "itemOffered": {
                                    "@type": "Service",
                                    "name": "Tłumaczenia Dokumentów",
                                    "description": "Profesjonalne tłumaczenia dokumentów prawnych, technicznych i biznesowych"
                                }
                            },
                            {
                                "@type": "Offer",
                                "itemOffered": {
                                    "@type": "Service",
                                    "name": "Lokalizacja Stron WWW",
                                    "description": "Kompleksowa lokalizacja serwisów internetowych i aplikacji"
                                }
                            },
                            {
                                "@type": "Offer",
                                "itemOffered": {
                                    "@type": "Service",
                                    "name": "Tłumaczenia Marketingowe",
                                    "description": "Specjalistyczne tłumaczenia materiałów marketingowych i reklamowych"
                                }
                            }
                        ]
                    }
                };

            case 'Article':
                return {
                    "@context": "https://schema.org",
                    "@type": "Article",
                    "headline": data.title,
                    "description": data.excerpt,
                    "image": data.image ? [data.image] : [],
                    "datePublished": data.datePublished,
                    "dateModified": data.dateModified || data.datePublished,
                    "author": {
                        "@type": "Organization",
                        "name": "Lingland",
                        "url": baseUrl
                    },
                    "publisher": {
                        "@type": "Organization",
                        "name": "Lingland",
                        "url": baseUrl,
                        "logo": {
                            "@type": "ImageObject",
                            "url": `${baseUrl}/logo192.png`,
                            "width": 192,
                            "height": 192
                        }
                    },
                    "mainEntityOfPage": {
                        "@type": "WebPage",
                        "@id": `${baseUrl}/blog/${data.slug}`
                    },
                    "articleSection": "Translation Industry",
                    "keywords": data.keywords || "tłumaczenia, lokalizacja, językoznawstwo"
                };

            case 'BreadcrumbList':
                return {
                    "@context": "https://schema.org",
                    "@type": "BreadcrumbList",
                    "itemListElement": data.breadcrumbs.map((item, index) => ({
                        "@type": "ListItem",
                        "position": index + 1,
                        "name": item.name,
                        "item": `${baseUrl}${item.url}`
                    }))
                };

            case 'FAQ':
                return {
                    "@context": "https://schema.org",
                    "@type": "FAQPage",
                    "mainEntity": data.faqs.map(faq => ({
                        "@type": "Question",
                        "name": faq.question,
                        "acceptedAnswer": {
                            "@type": "Answer",
                            "text": faq.answer
                        }
                    }))
                };

            default:
                return null;
        }
    };

    const schemaData = getSchemaData();

    if (!schemaData) {
        return null;
    }

    return (
        <Helmet>
            <script type="application/ld+json">
                {JSON.stringify(schemaData)}
            </script>
        </Helmet>
    );
};

export default SchemaMarkup;
